const courses = {
  udemyWebDevelopment:
    "https://www.udemy.com/course/the-complete-web-development-bootcamp/",
  udemyJavaScript:
    "https://www.udemy.com/course/the-complete-javascript-course/",
}

export default courses
